"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var NumberAbbreviate = /** @class */ (function () {
    function NumberAbbreviate(units) {
        if (units === void 0) { units = {}; }
        this.units = Object.keys(units)
            .map(function (unit) { return ({ unit: unit, value: units[unit] }); })
            .sort(function (a, b) { return a.value - b.value; });
    }
    NumberAbbreviate.prototype.abbreviate = function (num, options) {
        if (options === void 0) { options = {}; }
        var _a = options.precision, precision = _a === void 0 ? 2 : _a, commaOptions = options.commatize;
        var negative = num < 0;
        var raw = Math.abs(num);
        for (var i = this.units.length - 1; i >= 0; i -= 1) {
            var unit = this.units[i].unit;
            var size = this.units[i].value;
            if (raw >= size) {
                var result = utils_1.round(raw / size, precision);
                return (negative ? '-' : '')
                    + (commaOptions ? utils_1.commatize(result, commaOptions) : result)
                    + unit;
            }
        }
        return "" + num;
    };
    return NumberAbbreviate;
}());
exports.NumberAbbreviate = NumberAbbreviate;
var numabbr = new NumberAbbreviate({
    K: 1000,
    M: 1000000,
    B: 1000000000,
    T: 1000000000000,
});
function default_1(num, options) {
    return numabbr.abbreviate(num, options);
}
exports.default = default_1;
